import axios from "axios";

export default {
    name: "financing",
    state: {
        list: Array,
        pageMode: String,
        approval: null,
        information: {},
        financeDetail: {
            jkw_start_dt: null,
            jkw_end_dt: null,
            jml_fasilitas: 0,
            provisi: 0,
            biaya_admin: 0,
            type_financing: "FK",
        },
        financeHutang: []
    },
    getters: {
        getListFinancing: state => {
            return state.list
        },
        getApproval: state => {
            return state.approval
        },
        getInformationFinancing: state => {
            return state.information
        },
        getFinanceHutang: state => {
            return state.financeHutang
        },
        getFinanceDetail: state => {
            return state.financeDetail
        }
    },
    mutations: {
        setListFinancing: (state, payload) => {
            state.list = payload
        },
        setApproval: (state, payload) => {
            state.approval = payload
        },
        setInformationFinancing: (state, payload) => {
            state.information = payload
        },
        setFinanceHutang: (state, payload) => {
            state.financeHutang = [...state.financeHutang, { ...payload, id: payload.id_financing_dtl ? payload.id_financing_dtl : payload.id }]
        },
        setInitialFinancingHutang: (state) => {
            state.financeHutang = []
        },
        removeHutang: (state, payload) => {
            const source = [...state.financeHutang];
            const index = source.findIndex((data) => data === payload);

            source.splice(index, 1);
            state.financeHutang = source
        },
        editHutang: (state, payload) => {
            const source = [...state.financeHutang];
            const find = source.findIndex((item) => item.id === payload.id);

            if (find >= 0) {
                source[find] = payload
                state.financeHutang = source
            }
        },
        setFinanceDetail: (state, payload) => {
            state.financeDetail = payload
        },
        setInitialFinance: (state) => {
            state.approval = null;
            state.information = {};
            state.financeDetail = {
                jkw_start_dt: null,
                jkw_end_dt: null,
                jml_fasilitas: 0,
                provisi: 0,
                biaya_admin: 0,
                type_financing: "FK",
            };
            state.financeHutang = []
        },
        setPageMode: (state, payload) => {
            state.pageMode = payload
        }
    },
    actions: {
        getListFinancing(store, { auth }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: process.env.VUE_APP_SERVICEURL + "financing",
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    params: {
                        tlc: auth.username
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                    },
                })
                    .then((response) => {
                        store.commit("setListFinancing", response.data.data)
                        resolve(response.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getApproval(store, { auth }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: process.env.VUE_APP_SERVICEURL + "financing/getActorApproval",
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                    },
                })
                    .then((response) => {
                        store.commit("setApproval", response.data)
                        resolve(response.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        submitFinancing(store, { auth, payload, type }) {
            let url;
            if (store.state.pageMode == 'Create') {
                url = "financing"
            } else {
                url = "financing/editFinancing"
            }

            return new Promise((resolve, reject) => {
                axios({
                    method: "post",
                    url: process.env.VUE_APP_SERVICEURL + url,
                    data: payload,
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                        "Content-Type": "multipart/form-data",
                    },
                })
                    .then(({ data, status }) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getFinanceEdit(store, { auth, params }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: process.env.VUE_APP_SERVICEURL + "financing/revisi_financing",
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    params: {
                        id_financing: params.id,
                        tipe: params.type
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                    },
                })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        uploadDoc(store, { auth, payload }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "post",
                    url: process.env.VUE_APP_SERVICEURL + "financing/upload_lampiran",
                    data: payload,
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                        "Content-Type": "multipart/form-data",
                    },
                })
                    .then(({ data, status }) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
    },
};
